const LEGACY_PUBLIC_YANDEX_MAPS_API_KEY =
    "9133eb49-3a97-4b2d-90be-6b80a97a5036";

const YANDEX_MAP_LANGUAGES = Object.freeze({
    ru: "ru_RU",
    en: "en_US",
    cn: "en_US",
});

function resolveApiKey() {
    const configuredApiKey =
        process.env.REACT_APP_YANDEX_MAPS_API_KEY;

    if (
        configuredApiKey &&
        configuredApiKey.trim()
    ) {
        return configuredApiKey.trim();
    }

    return LEGACY_PUBLIC_YANDEX_MAPS_API_KEY;
}

export function createYandexMapsQuery(
    language = "ru"
) {
    return {
        lang:
            YANDEX_MAP_LANGUAGES[
                language
            ] ||
            YANDEX_MAP_LANGUAGES.ru,
        apikey: resolveApiKey(),
    };
}

export const YANDEX_MAPS_QUERY =
    Object.freeze(
        createYandexMapsQuery("ru")
    );
